import { default as MuiInput } from '@mui/material/Input';

/**
 * Input is the base text input element used within TextField.
 *
 * Demos:
 *
 * - [Text Field](https://unify.workiva.org/components/text-field?tab=code)
 *
 * API:
 *
 * - [Input API](https://unify.workiva.org/components/text-field?tab=props#input)
 */
export const Input = MuiInput;
export { type InputProps, inputClasses } from '@mui/material/Input';
